import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { LocationMapComponent } from './location-map.component';
import { SharedServicesFeatureModule } from '../../sharedServices/shared-services.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SharedServicesFeatureModule,
    GoogleMapsModule
  ],
  exports: [LocationMapComponent],
  declarations: [LocationMapComponent],
  providers: [],
})
export class LocationMapModule {}
